import React, {useEffect, useState} from 'react';
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import CheckList from "../lists/returnProductCheckList/CheckList";
import {useDispatch, useSelector} from "react-redux";
import {useActionListener} from "redux-action-listener-hook";
import {PRODUCT_RFID_TAG_DETECTED, VERIFIED_RETURN_OPENED, VERIFIED_RETURN_SUBMITTED} from "../../redux/actionTypes";
import {matchErplyProductWithPOSLog, PDTB} from "../../util/product";
import {addErrorAlert, findProduct, setLoading} from "../../redux/actions";
import parseBarcode from "../../redux/rfid/BarcodeParser.min";
import {createBarcode, ltrim, roundedPrice} from "../../util/helperFunctions";
import RFIDService from "../../redux/rfid/RFIDService";
import { PerfectScrollbarWithHotfix as PerfectScrollbar } from '../../uiComponents/WrappedPerfectScrollBar';
import ReturnedList from "../lists/returnProductCheckList/ReturnedList";
import {DECATHLON_SGTIN_DEFAULT} from "../../redux/appConstants";
import Decimal from "decimal.js";
import {getPenniesConf} from "../../integrations/pennies/Api";

const matchProduct = (listItems, product, setListItems) => {
    let matched = false;
    setListItems(listItems.map((item) => {
        if(matchErplyProductWithPOSLog(product, item.product.poslog)){
            item.checked = true;
            item.product.erplyProduct = product;
            matched = true;
        }
        console.log("match list item", {item});
        return item;
    }));
    return matched;
}

const selectProduct = (searchCode, serialNumber, dispatch, warehouseID, pointOfSaleID, listItems, setListItems, barcode, onDone=()=>{}, RFIDTag=false) => {
    console.log("Return POSLog scanner detected", {searchCode, serialNumber});
    dispatch(setLoading(true));
    dispatch(findProduct(searchCode, warehouseID, pointOfSaleID, false, (product) => {
        console.log("Return POSLog product found", {product});

        if(typeof serialNumber !== "undefined"){
            product.data.RFIDSerialNumber = serialNumber;
        }

        if(RFIDTag !== false){
            product.data.RFIDTag = RFIDTag;
        }

        let matched = matchProduct(listItems, product, setListItems);
        if(!matched){
            dispatch(addErrorAlert("Product not found on the sale receipt"));
        }
        onDone(matched);
        return setLoading(false);
    }, () => {
        console.log("Return POSLog product not found");
        onDone(false);
        dispatch(addErrorAlert("Product not found"));
        return setLoading(false);
    }, undefined, () => {
        dispatch(setLoading(false));
    }, undefined, false, barcode));
}

const getItemsFromPOSLog = (poslog, nonRefundableItems, type='sale') => {
    return poslog.transaction.retailTransaction.lineItem.reduce((acc, item) => {
        if( typeof item[type] !== "undefined" &&
            item[type].merchandiseHierarchy[0].id !== 'DKT:ShippingFee' &&
            nonRefundableItems.indexOf(item[type].itemID) === -1
        ){
            let price = roundedPrice(item[type].extendedAmount / item[type].quantity);
            let taxTotalAmount = item[type].tax.reduce((acc, el) => {
                acc += el.amount;
                return acc;
            },0);
            let netPrice = roundedPrice((item[type].extendedAmount - taxTotalAmount) / item[type].quantity);
            let product = {
                sequenceNumber: item.sequenceNumber,
                poslog: item,
                itemName: item[type].description.value,
                typeOfArticle: item[type].merchandiseHierarchy[0].id,
                code: item[type].itemID,
                amount: item[type].quantity,
                rowTotal: item[type].extendedAmount,
                price,
                netPrice
            };

            let epcs = item[type].serialNumber.filter(el => el.type === 'SGTIN' && el.value !== DECATHLON_SGTIN_DEFAULT);
            if(epcs.length > 0){
                let otherSerialNumbers = item[type].serialNumber.filter(el => el.type !== 'SGTIN');
                epcs.forEach(epc => {
                    acc.push({
                        checked: false,
                        product: {
                            ...product,
                            poslog: {
                                ...product.poslog,
                                [type]:{
                                    ...product.poslog[type],
                                    quantity: 1,
                                    serialNumber: [...otherSerialNumbers, epc]
                                }
                            },
                            amount: 1,
                            rowTotal: price
                        }
                    });
                });
            }else{
                acc.push({
                    checked: false,
                    product
                });
            }
        }
        return acc;
    }, []);
}

const getReturnedItemsFromPOSLogs = (poslogs) => {
    let amountByCodePrice = {};
    poslogs.forEach((poslog) => {
        poslog.poslog.transaction.retailTransaction.lineItem.forEach((el) => {
            if(typeof el.return !== "undefined"){
                let price = roundedPrice(el.return.extendedAmount / el.return.quantity);
                let codePrice = `${el.return.itemID}-${price}`;
                if(typeof amountByCodePrice[codePrice] === "undefined"){
                    amountByCodePrice[codePrice] = 0;
                }
                amountByCodePrice[codePrice] += el.return.quantity;
            }
        });
    });
    return amountByCodePrice;
}

const removeAlreadyReturnedItems = (listItems, returnedItems) => {
    return listItems.reduce((acc, el) => {
        let codePrice = `${el.product.code}-${el.product.price}`;
        if(typeof returnedItems[codePrice] !== "undefined"){
            if(el.product.amount >= returnedItems[codePrice]){
                el.product.amount -= returnedItems[codePrice];
                el.product.rowTotal = roundedPrice(el.product.price * el.product.amount);
                delete returnedItems[codePrice];
                if(el.product.amount !== 0){
                    acc.push(el);
                }
            }else{
                returnedItems[codePrice] -= el.product.amount;
            }
        }else{
            acc.push(el);
        }
        return acc;
    }, []);
}

const ReturnPOSLog = ({poslog, linkedPoslogs, onDone, onRFIDTagAdded, onManualSelect}) => {
    const warehouseID = useSelector(state => state.rootReducer.pos.warehouseID);
    const pointOfSaleID = useSelector(state => state.rootReducer.pos.pointOfSaleID);
    const penniesConf = useSelector(state => getPenniesConf(state));
    const dispatch = useDispatch();
    const nonRefundableItems = [];
    if(penniesConf !== false){
        nonRefundableItems.push(penniesConf.item);
    }

    const returnedItems = getReturnedItemsFromPOSLogs(linkedPoslogs);
    const [listItems, setListItems] = useState(removeAlreadyReturnedItems(getItemsFromPOSLog(poslog, nonRefundableItems), returnedItems));

    useEffect(() => {
        dispatch({
            type: VERIFIED_RETURN_OPENED,
            payload: {
                listItems
            }
        });
        return () => {}
    }, []);

    useActionListener('SCANNER_DETECTED', (dispatch, action) => {
        let searchCode = PDTB.tryAllpatterns(action.payload);
        let serialNumber;
        try {
            let barcode = parseBarcode(action.payload);
            let gtinItem = barcode.parsedCodeItems.find(el => el.dataTitle === 'GTIN');
            let serialItem = barcode.parsedCodeItems.find(el => el.dataTitle === 'SERIAL');

            if(typeof gtinItem !== "undefined" && typeof serialItem !== "undefined"){
                serialNumber = ltrim(serialItem.data, '0');
            }
            if(RFIDService.isAvailable() && typeof gtinItem !== "undefined" && typeof serialItem !== "undefined"){
                RFIDService.getEPCFromManualItem(gtinItem.data, serialNumber, "RETURN", (RFIDTag) => {
                    selectProduct(searchCode, serialNumber, dispatch, warehouseID, pointOfSaleID, listItems, setListItems, action.payload, (matched) => {
                        if(matched){
                            onRFIDTagAdded(RFIDTag);
                        }else{
                            RFIDService.cancelRFIDLine(RFIDTag, ()=>{});
                        }
                    }, RFIDTag);
                });
            }else{
                selectProduct(searchCode, serialNumber, dispatch, warehouseID, pointOfSaleID, listItems, setListItems, action.payload);
            }
        }catch (e){
            dispatch(addErrorAlert("Scan a barcode with a serial number!"));
        }
    });
    useActionListener(PRODUCT_RFID_TAG_DETECTED, (dispatch, action) => {
        let barcode = createBarcode(action.payload.RFIDTag.GTIN, action.payload.RFIDTag.SERIAL_NUMBER);
        selectProduct(action.payload.RFIDTag.GTIN, action.payload.RFIDTag.SERIAL_NUMBER, dispatch, warehouseID, pointOfSaleID, listItems, setListItems, barcode, (matched) => {
            if(matched){
                onRFIDTagAdded(action.payload.RFIDTag);
                RFIDService.removeTagFromRFIDProducts(action.payload.RFIDTag);
            }else{
                RFIDService.POSEvents.removePendingRfidTag(action.payload.RFIDTag);
            }
        }, action.payload.RFIDTag);
    });

    let previouslyReturned;
    if(linkedPoslogs.length > 0){
        previouslyReturned = <h2 style={{margin: "4.29rem 2.86rem 0"}}>
            <Translate id={"Previously returned"}/>
        </h2>;
    }

    return (
        <div>
            <h2>
                <Translate id={"Return"}/> {poslog.transaction?.receiptNumber?.value ?? poslog.transaction?.retailTransaction?.specialOrderNumber?.value ?? "" }
            </h2>
            <Button
                style={{
                    position: "absolute",
                    top: "1.43rem",
                    right: "7.14rem"
                }}
                type="button"
                className={"largeButton yellowButton"}
                name={<Translate id="Ok"/>}
                arrow="right"
                flencheClass={"flencheSmallRightBottom yellowFlenche"}
                onClick={() => {
                    let itemsSelectedCount = 0;
                    let itemsSelectedValue = 0;
                    let itemsTotalCount = 0;
                    let checkedProducts = listItems.reduce((acc, item) => {
                        itemsTotalCount += item.product.amount;
                        if(item.checked){
                            acc.push(item.product);
                            let returnQuantity = item.product?.returnAmount ?? item.product.amount;
                            itemsSelectedCount += returnQuantity;
                            itemsSelectedValue += (new Decimal(item.product.price)).mul(new Decimal(returnQuantity)).toDecimalPlaces(2).toNumber();
                        }
                        return acc;
                    }, []);
                    onDone(checkedProducts);
                    dispatch({
                        type: VERIFIED_RETURN_SUBMITTED,
                        payload: {
                            itemsSelectedCount,
                            itemsSelectedValue,
                            itemsTotalCount
                        }
                    })
                }}/>
            <div id={"productList"} style={{
                display: "contents"
            }}>
                <PerfectScrollbar style={{
                    position: "absolute",
                    left: 0,
                    right:0,
                    top: "4.29rem",
                    bottom: 0,
                    height: "auto"
                }}>
                    {
                        listItems.length > 0 ?
                            <CheckList
                                listItems={listItems}
                                setListItems={(updatedListItems, checked, onFail) => {
                                    onManualSelect(checked).then(() => {
                                        setListItems(updatedListItems);
                                    }, () => {
                                        setListItems(listItems);
                                        onFail();
                                    });
                                }}
                                readonly={!window.AppConf.verifiedReturn.manual}
                            /> :
                            <p style={{margin: "2.86rem"}}><Translate id={"All products already returned!"}/></p>
                    }

                    { previouslyReturned }
                    {
                        linkedPoslogs.map((linkedPosLog, index) => {
                            return <div key={index}>
                                <h3 style={{margin: "2.14rem 2.86rem 0"}}>
                                    { linkedPosLog.poslog.transaction?.receiptNumber?.value ??
                                      linkedPosLog.poslog.transaction?.retailTransaction?.specialOrderNumber?.value ??
                                      ""
                                    }
                                </h3>
                                <ReturnedList
                                    listItems={getItemsFromPOSLog(linkedPosLog.poslog, nonRefundableItems, 'return')}
                                />
                            </div>
                        })
                    }
                </PerfectScrollbar>
            </div>
        </div>
    );
};

export default ReturnPOSLog;
